import React from "react";
import { CircularProgress } from "@mui/material";

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <CircularProgress />
    </div>
  );
};

export default LoadingScreen;
